import React from 'react';

import { SvgProps } from '../enums';

export const FlagBT: React.FC<SvgProps> = ({ size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_270_55195"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="12"
    >
      <rect width="16" height="12" fill="white" />
    </mask>
    <g mask="url(#mask0_270_55195)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H16V12H0V0Z"
        fill="#FF6230"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0V12L16 0H0Z"
        fill="#FECA00"
      />
      <g filter="url(#filter0_d_270_55195)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          // eslint-disable-next-line max-len
          d="M2.19111 8.16443C2.19111 8.16443 1.43952 8.8492 2.03545 8.88524C2.63133 8.92134 2.51961 9.28458 3.0071 8.88733C3.49458 8.49001 3.02172 8.95048 3.67193 8.86021C4.32192 8.76987 4.64689 7.97678 4.99014 8.03098C5.33307 8.0851 5.13444 7.95872 5.42337 8.30178C5.71236 8.64494 6.21999 7.91645 5.94908 8.4221C5.67837 8.92767 5.56998 9.43324 5.9673 9.41519C6.36448 9.39717 6.52699 9.16239 6.70753 8.90961C6.88813 8.65682 8.29673 9.52362 7.64673 8.65682C6.99652 7.79 6.74435 8.75182 6.69023 8.3004C6.63609 7.84896 6.50693 7.61419 6.814 7.8309C7.12075 8.04755 7.84323 7.99342 7.28328 7.45163C6.72357 6.90995 6.80149 6.76553 6.63871 6.90995C6.47626 7.05438 6.07896 6.36823 6.63871 6.27796C7.19848 6.18762 7.84323 6.49457 8.05987 6.65709C8.27665 6.81968 8.94482 6.62102 9.08918 6.94594C9.23367 7.2711 9.72123 7.32525 9.84758 7.52392C9.97418 7.72262 9.88374 8.69766 10.913 8.6435C11.9423 8.58926 12.2673 8.06564 11.8341 7.65029C11.4005 7.23499 11.4368 6.47651 10.9853 6.83773C10.5339 7.19881 9.88374 7.14464 9.88374 6.71129C9.88374 6.27796 10.0824 6.20572 10.0463 5.86258C10.0101 5.51942 9.97417 5.66392 10.6423 5.68194C11.3103 5.70004 11.0755 5.68194 11.563 5.44728C12.0507 5.21251 12.3757 6.24179 12.5744 5.48331C12.773 4.725 12.5022 3.94843 11.9605 4.25542C11.4187 4.56239 11.4368 5.32083 10.7505 4.725C10.0644 4.12896 9.73938 4.43595 9.95603 4.11091C10.1726 3.78595 9.90183 3.55117 10.3894 3.76779C10.8769 3.98462 10.7326 4.05675 11.1478 4.11091C11.563 4.16507 13.7662 4.43595 13.2787 3.98462C12.7912 3.53312 12.323 3.60675 12.2508 3.31774C12.1785 3.02888 12.4759 3.1011 12.9092 2.93862C13.3427 2.77606 13.162 1.94534 12.7465 2.1079C12.3313 2.27049 12.3668 2.99278 11.5181 2.54125C10.5443 2.96486 10.695 2.7523 10.1992 2.03435C9.7656 1.69114 9.53087 1.6732 8.79063 2.07034C8.20631 2.31143 7.71739 2.75657 8.02442 3.35259C8.3315 3.94843 9.06269 5.07079 8.6655 5.14301C8.26819 5.21521 6.84165 4.14979 6.01096 4.70972C5.18023 5.26937 4.7268 5.81411 4.4561 6.46414C4.18519 7.11429 3.30866 7.49284 3.09189 7.49284C2.87525 7.49284 2.57014 7.8755 2.19111 8.16443Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_270_55195"
        x="-0.194336"
        y="-0.225342"
        width="15.5431"
        height="11.641"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.866667 0 0 0 0 0.184314 0 0 0 0 0 0 0 0 0.38 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_270_55195"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_270_55195"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
